"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultDevicePixelRatioMonitor_1 = require("../devicepixelratiomonitor/DefaultDevicePixelRatioMonitor");

var DevicePixelRatioWindowSource_1 = require("../devicepixelratiosource/DevicePixelRatioWindowSource");

var Types_1 = require("../utils/Types");

var DefaultVideoTileController = /*#__PURE__*/function () {
  function DefaultVideoTileController(tileFactory, audioVideoController, logger) {
    _classCallCheck(this, DefaultVideoTileController);

    this.tileFactory = tileFactory;
    this.audioVideoController = audioVideoController;
    this.logger = logger;
    this.tileMap = new Map();
    this.nextTileId = 1;
    this.currentLocalTile = null;
    this.currentPausedTilesByIds = new Set();
    this.keepLastFrameWhenPaused = false;
    this.keepLastFrameWhenPaused = audioVideoController.configuration.keepLastFrameWhenPaused;
  }

  _createClass(DefaultVideoTileController, [{
    key: "createDevicePixelRatioMonitorIfNeeded",
    value: function createDevicePixelRatioMonitorIfNeeded() {
      if (this.devicePixelRatioMonitor) {
        return;
      }

      this.devicePixelRatioMonitor = new DefaultDevicePixelRatioMonitor_1.default(new DevicePixelRatioWindowSource_1.default(), this.logger);
    }
  }, {
    key: "discardDevicePixelRatioMonitorIfNotNeeded",
    value: function discardDevicePixelRatioMonitorIfNotNeeded() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var monitor;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.tileMap.size || !this.devicePixelRatioMonitor)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                monitor = this.devicePixelRatioMonitor;
                this.devicePixelRatioMonitor = undefined;
                return _context.abrupt("return", monitor.destroy());

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "bindVideoElement",
    value: function bindVideoElement(tileId, videoElement) {
      var tile = this.getVideoTile(tileId);

      if (tile === null) {
        this.logger.warn("Ignoring video element binding for unknown tile id ".concat(tileId));
        return;
      }

      tile.bindVideoElement(videoElement);
    }
  }, {
    key: "unbindVideoElement",
    value: function unbindVideoElement(tileId) {
      this.bindVideoElement(tileId, null);
    }
  }, {
    key: "startLocalVideoTile",
    value: function startLocalVideoTile() {
      var tile = this.findOrCreateLocalVideoTile();
      this.currentLocalTile.stateRef().localTileStarted = true;
      this.audioVideoController.update({
        needsRenegotiation: true
      });
      return tile.id();
    }
  }, {
    key: "stopLocalVideoTile",
    value: function stopLocalVideoTile() {
      if (!this.currentLocalTile) {
        return;
      }

      this.currentLocalTile.stateRef().localTileStarted = false;
      this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
      this.audioVideoController.update({
        needsRenegotiation: true
      });
    }
  }, {
    key: "hasStartedLocalVideoTile",
    value: function hasStartedLocalVideoTile() {
      return !!(this.currentLocalTile && this.currentLocalTile.stateRef().localTileStarted);
    }
  }, {
    key: "removeLocalVideoTile",
    value: function removeLocalVideoTile() {
      if (this.currentLocalTile) {
        this.removeVideoTile(this.currentLocalTile.id());
      }
    }
  }, {
    key: "getLocalVideoTile",
    value: function getLocalVideoTile() {
      return this.currentLocalTile;
    }
  }, {
    key: "pauseVideoTile",
    value: function pauseVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);

      if (tile) {
        if (!this.currentPausedTilesByIds.has(tileId)) {
          this.audioVideoController.pauseReceivingStream(tile.stateRef().streamId);
          this.currentPausedTilesByIds.add(tileId);
        }

        tile.pause();
      }
    }
  }, {
    key: "unpauseVideoTile",
    value: function unpauseVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);

      if (tile) {
        if (this.currentPausedTilesByIds.has(tileId)) {
          this.audioVideoController.resumeReceivingStream(tile.stateRef().streamId);
          this.currentPausedTilesByIds.delete(tileId);
        }

        tile.unpause();
      }
    }
  }, {
    key: "getVideoTile",
    value: function getVideoTile(tileId) {
      return this.tileMap.has(tileId) ? this.tileMap.get(tileId) : null;
    }
  }, {
    key: "getVideoTileArea",
    value: function getVideoTileArea(tile) {
      var state = tile.state();
      var tileHeight = 0;
      var tileWidth = 0;

      if (state.boundVideoElement) {
        tileHeight = state.boundVideoElement.clientHeight * state.devicePixelRatio;
        tileWidth = state.boundVideoElement.clientWidth * state.devicePixelRatio;
      }

      return tileHeight * tileWidth;
    }
  }, {
    key: "getAllRemoteVideoTiles",
    value: function getAllRemoteVideoTiles() {
      var _this = this;

      var result = new Array();
      this.tileMap.forEach(function (tile, tileId) {
        if (!_this.currentLocalTile || tileId !== _this.currentLocalTile.id()) {
          result.push(tile);
        }
      });
      return result;
    }
  }, {
    key: "getAllVideoTiles",
    value: function getAllVideoTiles() {
      return Array.from(this.tileMap.values());
    }
  }, {
    key: "addVideoTile",
    value: function addVideoTile() {
      var localTile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var tileId = this.nextTileId;
      this.nextTileId += 1;
      this.createDevicePixelRatioMonitorIfNeeded();
      var tile = this.tileFactory.makeTile(tileId, localTile, this, this.devicePixelRatioMonitor);
      this.tileMap.set(tileId, tile);
      return tile;
    }
  }, {
    key: "removeVideoTile",
    value: function removeVideoTile(tileId) {
      if (!this.tileMap.has(tileId)) {
        return;
      }

      var tile = this.tileMap.get(tileId);

      if (this.currentLocalTile === tile) {
        this.currentLocalTile = null;
      }

      tile.destroy();
      this.tileMap.delete(tileId);
      this.audioVideoController.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.videoTileWasRemoved).map(function (f) {
          return f.bind(observer)(tileId);
        });
      });
      this.discardDevicePixelRatioMonitorIfNotNeeded();
    }
  }, {
    key: "removeVideoTilesByAttendeeId",
    value: function removeVideoTilesByAttendeeId(attendeeId) {
      var tilesRemoved = [];

      var _iterator = _createForOfIteratorHelper(this.getAllVideoTiles()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tile = _step.value;
          var state = tile.state();

          if (state.boundAttendeeId === attendeeId) {
            this.removeVideoTile(state.tileId);
            tilesRemoved.push(state.tileId);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return tilesRemoved;
    }
  }, {
    key: "removeAllVideoTiles",
    value: function removeAllVideoTiles() {
      var tileIds = Array.from(this.tileMap.keys());

      for (var _i = 0, _tileIds = tileIds; _i < _tileIds.length; _i++) {
        var tileId = _tileIds[_i];
        this.removeVideoTile(tileId);
      }
    }
  }, {
    key: "sendTileStateUpdate",
    value: function sendTileStateUpdate(tileState) {
      this.audioVideoController.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.videoTileDidUpdate).map(function (f) {
          return f.bind(observer)(tileState);
        });
      });
    }
  }, {
    key: "haveVideoTilesWithStreams",
    value: function haveVideoTilesWithStreams() {
      var _iterator2 = _createForOfIteratorHelper(this.getAllVideoTiles()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tile = _step2.value;

          if (tile.state().boundVideoStream) {
            return true;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return false;
    }
  }, {
    key: "haveVideoTileForAttendeeId",
    value: function haveVideoTileForAttendeeId(attendeeId) {
      return !!this.getVideoTileForAttendeeId(attendeeId);
    }
  }, {
    key: "getVideoTileForAttendeeId",
    value: function getVideoTileForAttendeeId(attendeeId) {
      var _iterator3 = _createForOfIteratorHelper(this.getAllVideoTiles()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tile = _step3.value;
          var state = tile.state();

          if (state.boundAttendeeId === attendeeId) {
            return tile;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return undefined;
    }
  }, {
    key: "captureVideoTile",
    value: function captureVideoTile(tileId) {
      var tile = this.getVideoTile(tileId);

      if (!tile) {
        return null;
      }

      return tile.capture();
    }
  }, {
    key: "findOrCreateLocalVideoTile",
    value: function findOrCreateLocalVideoTile() {
      if (this.currentLocalTile) {
        return this.currentLocalTile;
      }

      this.currentLocalTile = this.addVideoTile(true);
      this.currentLocalTile.bindVideoStream(this.audioVideoController.configuration.credentials.attendeeId, true, null, null, null, null, this.audioVideoController.configuration.credentials.externalUserId);
      return this.currentLocalTile;
    }
  }]);

  return DefaultVideoTileController;
}();

exports.default = DefaultVideoTileController;